import styled from 'styled-components';

import theme from '../../../../styles/defaultTheme';

export const CustomStatusTagContainer = styled.div`
	width: 86px ;
	height: 20px;
	margin: 0;
	border-radius: 10px;
  	background-color: ${(props) => (props.id === 1 ? props.theme.success10 : props.theme.error10)};
	font-size: ${theme.font.size12};
	font-weight: bold;
	text-align: center;
	color: ${(props) => (props.id === 1 ? props.theme.green : props.theme.red)};
	border: solid 1px ${(props) => props.theme.borderWhite};
`;
